import { memo, useCallback, useEffect, useState, createRef, useMemo } from 'react';
import { Text, View, StyleSheet, Keyboard } from 'react-native';

import { SuggestionList, ProfileAvatar } from '../components';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__, __ANDROID__ } from '../../constants/styles';

let textBeginning = '',
  textEnding = '';
let _ats = {};

function checkInputForAtTag(inputSelection, fullText) {
  const cursorPosition = inputSelection?.end;
  const words = fullText.slice(0, cursorPosition).split(' ');
  let word;
  if (words.length) {
    word = words[words.length - 1];
  }

  let atWord;
  if (word.indexOf('@') > -1) {
    const atWords = word.split('@');
    atWord = atWords[atWords.length - 1];
  }

  if (atWord) {
    textBeginning = fullText.slice(0, cursorPosition - (atWord.length + 1));
    textEnding = fullText.slice(cursorPosition);
    atWord = atWord.replaceAll('_', ' ');
  }

  return atWord;
}

function getFullTextWithMemberTag(inputString, itemId) {
  // cheeply allow for 4 duplicate rank / name combos
  const origString = inputString;
  if (_ats[inputString] && _ats[inputString] !== itemId) {
    inputString = `${origString}_2`;
    if (_ats[inputString] && _ats[inputString] !== itemId) {
      inputString = `${origString}_3`;
      if (_ats[inputString] && _ats[inputString] !== itemId) {
        inputString = `${origString}_4`;
      }
    }
  }
  _ats[inputString] = itemId;

  const trimmedEnd = textEnding.trim();

  return `${textBeginning}@${inputString} ${trimmedEnd}`;
}

function renderParticipantSelectItem(item) {
  if (!item || !item.id) return null;

  const profile = item.profile;
  const label = `${profile.rank ? profile.rank + ' ' : ''}${profile.fullName}`;
  return (
    <View style={styles.participantItemRow}>
      <ProfileAvatar
        profile={profile}
        circleStyles={{ width: 30, height: 30 }}
        containerStyles={{ justifyContent: 'center' }}
      />
      <Text style={styles.participantName}>{label}</Text>
    </View>
  );
  return null;
}

export default memo(function(props) {
  const [inputAtValue, setInputAtValue] = useState(null);

  const participantItems = useMemo(
    () => {
      return props.members.map(profile => {
        return {
          label: `${profile.rank ? profile.rank + ' ' : ''}${profile.fullName}`,
          id: profile.userId,
          profile,
        };
      });
    },
    [props.members]
  );

  const keyboardOffset = props.keyboardHeight ? props.keyboardHeight - props.bottomOffset : 0;
  const bottomStyle = { bottom: props.composerHeight + keyboardOffset };

  const handleAtInput = useCallback((inputSelection, fullText) => {
    const atWord = checkInputForAtTag(inputSelection, fullText);
    setInputAtValue(atWord);
  }, []);
  if (__WEB__) {
    useEffect(
      function() {
        handleAtInput(props.inputSelection, props.text);
      },
      [props.inputSelection]
    );
  } else {
    useEffect(
      function() {
        handleAtInput(props.inputSelection, props.text);
      },
      [props.text]
    );
  }

  const handleSelectParticipant = useCallback(({ value, item }) => {
    if (!item) return;
    let inputString = item.label.replaceAll(' ', '_');

    const newFullText = getFullTextWithMemberTag(inputString, item.id);

    props.onText(newFullText);
    props.onAts(_ats);
  }, []);

  return (
    <View style={[styles.suggestionListContainerContainer, bottomStyle]} pointerEvents="box-none">
      <View style={[styles.suggestionListContainer]} pointerEvents="box-none">
        <SuggestionList
          items={participantItems}
          inputStyle={styles.textInput}
          containerStyle={styles.participantListBox}
          defaultValue={null}
          onValue={handleSelectParticipant}
          externalValue={inputAtValue}
          placeholderText={props.placeholder}
          searchMode={true}
          autoFocus={false}
          inverted={true}
          hideInput={true}
          renderItem={renderParticipantSelectItem}
        />
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  suggestionListContainerContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
  },
  suggestionListContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  participantItemRow: {
    ...THEME.basicRow,
    backgroundColor: COLOR.altContrast,
    borderBottomWidth: 1,
    borderColor: COLOR.accent,
    paddingVertical: 5,
  },
  participantListBox: {
    borderTopWidth: 1,
    borderColor: COLOR.accent,
  },
  participantName: {
    ...THEME.linkStyle,
    marginLeft: 5,
  },
});
